// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2TvYt","header":"Messages_header__1on_u"};